import React from 'react';
import PropTypes from 'prop-types';


export default class QuestionTag extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
        materials: PropTypes.object,
        subjects: PropTypes.object,
        labels: PropTypes.object,
        readonly: PropTypes.bool,
        selectable: PropTypes.bool,
    };

    render() {
        // debugger;
        const renderer = document.createElement('div');
        renderer.innerHTML = this.props.store.get('content');
        let questionContent = renderer.innerText;
        if (this.props.store.get('fake'))
            questionContent = '--- ' + window.gettext('Fake') + ' ---';
        return <div
            key={this.props.store.get('id')}
            style={{
                border: '.0625em solid',
                borderColor: this.props.store.get('key') === 0 ? '#ff0500' : (this.props.store.get("subjects") !== undefined && this.props.store.get("subjects").size) === 0 ? '#ff00b7' : '#bbbbbb',
                margin: '.2em',
                overflow: 'hidden',
                height: '3.2em',
                cursor: 'pointer',
                backgroundColor: this.props.selected ? '#b5d9f0' : 'inherit',
            }}>
            <div
                style={{
                    paddingTop: '.2em',
                    position: 'relative',
                    minHeight: 'calc(3.2em - .2em)',
                    pointerEvents: 'none',
                    padding: '.25em',
                }}>
                {this.props.store.get('question_id')
                    ? <div style={{fontSize: '.8em'}}>
                        {(this.props.store.get('index') + 1).persian()} - {this.props.store.get('question_id').persian()}.
                        &nbsp;
                        {questionContent}
                    </div>
                    : null
                }
                {this.props.store.get('note')
                    ? <div style={{fontSize: '.8em'}}>
                        {window.gettext('Note')}: {this.props.store.get('note')}
                    </div>
                    : null
                }
            </div>
        </div>;
    }
}
